/**
 * @ignore
 */
export const environment = {
  production: false,
  vsolServerDomain: 'poc.wr.management.dtymr.tk',
  vsolServerUrl: 'https://poc.wr.management.dtymr.tk/VineyardWeb',
  idcsOAuthUrl:
    'https://idcs-6e511eeb0a12454fb8bd93d2e1253945.identity.oraclecloud.com',
  idcsClientIdAndSecret:
    'ZjBhY2NkZGM2NDg1NDg3Mzg5ZTAxYTJmMjhlZWNjMWY6MjQwOTk0ZTEtYjM1OC00OTk2LTljNjAtYThjMmIwMTU2YWUw',
};
